import { device, mtrStyle } from 'src/styles/global';
import styled from 'styled-components';
import theme from 'src/styles/theme';

interface Props {
  isOpen: boolean;
}

export const NavContainer = styled.div<Props>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  background: ${theme.colors.neutralC100};
  position: sticky;
  top: 0;
  width: 100%;
  padding: 24px;
  z-index: 998;

  @media ${device.mobile} {
    position: fixed;
    top: 0;
    left: 0;
    background: ${theme.colors.white0};
    padding: 16px;
    border-radius: 0px 0px 5px 5px;
    border-bottom: 1px solid ${theme.colors.mtr60};
    box-shadow: ${({ isOpen }) =>
      isOpen ? `0px 0px 8px 0px rgba(0, 0, 0, 0.25)` : 'none'};
    border-bottom: ${({ isOpen }) =>
      isOpen ? `1px solid ${theme.colors.mtr60}` : 'none'};
  }

  @media ${device.tablet} {
    padding: 16px;
    background: ${theme.colors.neutralC100};
  }

  @media ${device.ipad} {
    padding: 16px;
    background: ${theme.colors.neutralC100};
  }
`;

export const SidebarMobile = styled.div`
  display: none;
  flex-direction: column;
  cursor: pointer;

  span {
    height: 2px;
    width: 20px;
    background: ${theme.colors.mtr60};
    margin-bottom: 4px;
    border-radius: ${mtrStyle.borderRadius};
  }

  @media ${device.mobile} {
    display: flex;
  }
`;

export const LogoWrapperMobile = styled.div`
  display: none;

  @media ${device.mobile} {
    display: flex;
    svg {
      width: 110px;
      height: 40px;
    }
  }
`;

export const LogoWrapperDesktop = styled.div`
  display: flex;

  @media ${device.mobile} {
    display: none;
  }
`;

export const AccountBadgeMobileWrapper = styled.div`
  display: none;

  @media ${device.mobile} {
    display: flex;
  }
`;

export const Menu = styled.div<Props>`
  display: flex;
  justify-content: space-between;

  @media ${device.mobile} {
    flex-direction: column;
    width: 100%;
    max-height: ${({ isOpen }) => (isOpen ? 'fit-content' : '0')};
    overflow: ${({ isOpen }) => (isOpen ? '' : 'hidden')};
    transition: max-height 0.1s ease-out;
  }
`;

export const MenuItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 24px;

  @media ${device.mobile} {
    flex-direction: column;
    align-items: flex-start;
    margin-top: 32px;
    gap: 6px;
  }

  @media ${device.tablet} {
    align-items: center;
    gap: 16px;
  }

  @media ${device.ipad} {
    align-items: center;
    gap: 16px;
  }
`;

export const AccountInfoWrapper = styled.div`
  display: none;
  flex-direction: column;
  padding: 8px 16px;
  border-radius: 5px;
  border: 1px solid ${theme.colors.neutralW100};
  width: 100%;
  gap: 16px;

  @media ${device.mobile} {
    display: flex;
  }
`;

export const AccountNameEmailWrapper = styled.div`
  display: none;
  flex-direction: row;
  align-items: center;
  gap: 8px;

  @media ${device.mobile} {
    display: flex;
  }
`;

export const AccountNameWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ItemDropdownMobile = styled.div`
  display: none;
  justify-content: space-between;
  width: 100%;
  cursor: pointer;
  color: ${theme.colors.neutralW40};

  @media ${device.mobile} {
    display: flex;
  }
`;

export const ItemDropdownButton = styled.button`
  display: flex;
  align-items: center;
  font-size: 16px;
  line-height: 16px;
  color: ${theme.colors.neutralW40};
  outline: none;
  border: none;
  border-radius: 5px;
  background: none;
  cursor: pointer;
  padding: 0px;
  gap: 8px;
`;

export const ItemDescMobile = styled.div<Props>`
  display: none;
  flex-direction: row;
  justify-content: flex-start;
  font-size: 12px;
  color: ${theme.colors.neutralW40};

  @media ${device.mobile} {
    display: ${({ isOpen }) => (isOpen ? 'flex' : 'none')};
  }
`;

export const IconWrapper = styled.div`
  display: flex;
  svg {
    width: 20px;
    height: 20px;
  }
`;

export const PromoPriceButton = styled.button`
  display: flex;
  align-items: center;
  align-self: center;
  font-size: 16px;
  color: ${theme.colors.mtr60};
  outline: none;
  border: none;
  border-radius: 5px;
  background: none;
  cursor: pointer;
  padding: 10px;
  gap: 8px;
  white-space: nowrap;

  @media ${device.mobile} {
    padding: 10px 0px 10px;
  }
`;

export const PricingButton = styled.button`
  display: flex;
  align-items: center;
  align-self: center;
  font-size: 16px;
  color: ${theme.colors.neutralW40};
  outline: none;
  border: none;
  border-radius: 5px;
  background: none;
  cursor: pointer;
  padding: 10px;
  gap: 8px;
  white-space: nowrap;

  @media ${device.mobile} {
    padding: 10px 0px 10px;
  }
`;

export const StationListButtonMobile = styled.button`
  display: none;
  font-size: 16px;
  color: ${theme.colors.neutralW40};
  outline: none;
  border: none;
  border-radius: 5px;
  background: none;
  cursor: pointer;
  padding: 10px 0px 10px;
  gap: 8px;

  svg {
    width: 20px;
    height: 20px;
  }

  @media ${device.mobile} {
    display: flex;
  }
`;

export const PreferencesButtonMobile = styled.button`
  display: none;
  font-size: 16px;
  color: ${theme.colors.neutralW40};
  outline: none;
  border: none;
  border-radius: 5px;
  background: none;
  cursor: pointer;
  padding: 10px 0px 10px;
  gap: 8px;

  svg {
    align-self: center;
    width: 20px;
    height: 20px;
  }

  @media ${device.mobile} {
    display: flex;
  }
`;

export const SignoutButtonMobile = styled.button`
  display: none;
  font-size: 16px;
  color: ${theme.colors.neutralW40};
  outline: none;
  border: none;
  border-radius: 5px;
  background: none;
  cursor: pointer;
  padding: 0px;
  gap: 8px;
  width: 100%;
  padding: 10px 0px 0px;
  border-top: 1px solid ${theme.colors.neutralW100};

  svg {
    align-self: center;
    width: 20px;
    height: 20px;
  }

  @media ${device.mobile} {
    display: flex;
  }
`;

export const MenuItemWrapper = styled.div`
  height: 42px;

  @media ${device.mobile} {
    display: none;
  }
`;
